<template>
  <base-modal ref="modal">
    <base-card v-if="selectedPlan" shadow>
      <h3 class="tw-text-xl tw-font-thin">Edit Payment Method for {{ isUpdateAll ? "All Plans" : selectedPlan.planName }}</h3>
      <base-credit-card-input ref="creditCardInput" class="tw-mt-3" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse">
        <base-button @click="update" :loading="isUpdating" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Update</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
export default {
  props: {
    userId: String,
  },
  data() {
    return {
      isUpdating: false,
      selectedPlans: {},
    };
  },
  computed: {
    selectedPlan() {
      return this.selectedPlans.length === 1 ? this.selectedPlans[0] : {};
    },
    isUpdateAll() {
      return this.selectedPlans.length > 1;
    },
  },
  methods: {
    show(selectedPlans) {
      this.selectedPlans = selectedPlans;
      this.$refs.modal.show();
      this.$refs.creditCardInput.reset();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async update() {
      try {
        this.isUpdating = true;
        this.token = await this.$refs.creditCardInput.createToken();
        if (!this.token) return;
        const promises = this.selectedPlans.map(async (sp) => {
          const token = await this.$refs.creditCardInput.createToken();
          await this.$axios.put(`/businesses/${sp.businessId}/members/${this.userId}/plans/${sp.userBusinessPlanId}/creditcard`, {
            stripeToken: token.id,
          });
        });
        await Promise.all(promises);

        this.$emit("updated");
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Payment Card Updated", message: "You successfully updated your card information" });
        this.hide();
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Update Failed",
          message: "Your card update failed",
          error,
        });
      } finally {
        this.isUpdating = false;
      }
    },
  },
};
</script>
